const migrations = {
	1: (state) => {
		localStorage.removeItem('auth')
		localStorage.removeItem('setsView')
		localStorage.removeItem('setSortBy')
		localStorage.removeItem('setView')

		return state
	},
	2: (state) => {
		const languageMigrations = {
			'en-FR': 'fr-FR',
			'en-IT': 'it-IT',
			'en-ES': 'es-ES',
			'en-PT': 'pt-PT'
		}

		if (languageMigrations[state.persist.language]) {
			return {
				...state,
				persist: {
					...state.persist,
					language: languageMigrations[state.persist.language]
				}
			}
		}

		return state
	}
}

export default migrations
